import {Component} from 'react';
import PropTypes from 'prop-types';
import {Enums} from '_app/utils';
import {PopoverHeader, PopoverContent, PopoverFooter, Button} from '@emoney/kyber';
import {appConfigService} from '_app/services';
import SocialSection from './components/SocialSection';
import LinkSection from './components/LinkSection';
import EmbedSection from './components/EmbedSection';
import {SOCIAL_SHARE, LINK_SHARE, EMBED_SHARE} from './SharePopoverContentConstants';
import {userInfoShape} from '_app/shapes';
import './share-popover-content.less';

const shareTypes = Enums.getType('shareTypes');
const mediaTypes = Enums.getType('mediaTypes');

class SharePopoverContent extends Component {
	state = {
		expanded: {
			[SOCIAL_SHARE]: true,
			[LINK_SHARE]: false,
			[EMBED_SHARE]: false
		}
	}

	fetchShareTexts = () => this.props.loadShareTexts(this.props.media.ID)

	expandSocialSection = () => this.expandSection(SOCIAL_SHARE);

	expandLinkSection = () => this.expandSection(LINK_SHARE);

	expandEmbedSection = () => this.expandSection(EMBED_SHARE);

	expandSection(type) {
		this.setState({
			expanded: {
				...this.state.expanded,
				[type]: !this.state.expanded[type]
			}
		});
	}

	getEmailLink = () => this.getShareLink(shareTypes.EMAIL);

	getEmbedLink = () => this.getShareLink(shareTypes.EMBED);

	getMediashareLink = () => this.getShareLink(shareTypes.LINK);

	getShareLink(type) {
		this.props.fetchShareLink(
			this.props.media.ID,
			this.props.media.Version,
			this.props.proxiedAs ? this.props.proxiedAs.userID : null,
			type,
			this.props.proxiedAs ? this.props.proxiedAs.partnerID : null
		);
	}

	onHide = () => {
		this.setState({
			expanded: {
				[SOCIAL_SHARE]: true,
				[LINK_SHARE]: false,
				[EMBED_SHARE]: false
			}
		});
		this.props.onHide();
	}

	openInNewTab = (url) => {
		const newWindow = window.open(url, '_blank', 'noopener,noreferrer');

		if (newWindow) {
			newWindow.opener = null;
		}
	}

	previewMedia = () => {
		this.openInNewTab(this.props.shareLinks[shareTypes.LINK].link.concat('&isPreview=true'));
	}

	render() {
		const allowSocial = appConfigService.get('allowSocial') && this.props.media.ShareSettings.SocialShare;
		const allowEmail = appConfigService.get('allowEmail') && this.props.media.ShareSettings.EmailShare;
		const allowLink = this.props.media.ShareSettings.LinkShare;
		const allowEmbed = this.props.media.Type === mediaTypes.VIDEO && this.props.media.ShareSettings.EmbedShare;
		const mediaTypeName = mediaTypes.properties[this.props.media.Type].name;

		return (
			<div className="share-popover-content-container">
				<PopoverHeader id={this.props.titleId}>
					{`Share this ${mediaTypeName}: ${this.props.media.Name}`}
				</PopoverHeader>
				<PopoverContent className="share-popover-content">
					{(allowEmail || allowSocial) && (
						<SocialSection
							allowEmail={allowEmail}
							allowSocial={allowSocial}
							expanded={this.state.expanded[SOCIAL_SHARE]}
							linkObj={this.props.shareLinks[shareTypes.EMAIL]}
							getEmailLink={this.getEmailLink}
							fetchShareTexts={this.fetchShareTexts}
							proxiedAs={this.props.proxiedAs}
							media={this.props.media}
							shareTexts={this.props.shareTexts.social}
							expandSection={this.expandSocialSection}
							addShareItem={this.props.addShareItem}
						/>
					)}
					{allowLink && (
						<LinkSection
							mediaTypeName={mediaTypeName.toLowerCase()}
							linkObj={this.props.shareLinks[shareTypes.LINK]}
							expanded={this.state.expanded[LINK_SHARE]}
							getLink={this.getMediashareLink}
							proxiedAs={this.props.proxiedAs}
							expandSection={this.expandLinkSection}
						/>
					)}
					{allowEmbed && (
						<EmbedSection
							linkObj={this.props.shareLinks[shareTypes.EMBED]}
							expanded={this.state.expanded[EMBED_SHARE]}
							getLink={this.getEmbedLink}
							expandSection={this.expandEmbedSection}
						/>
					)}
				</PopoverContent>
				<PopoverFooter>
					<Button id="media-preview-button" onClick={this.previewMedia} primary disabled={!(this.props.shareLinks[shareTypes.LINK])}>
						Preview
					</Button>
					<Button onClick={this.onHide}>
						Cancel
					</Button>
				</PopoverFooter>
			</div>
		);
	}
}

SharePopoverContent.propTypes = {
	titleId: PropTypes.string.isRequired,
	media: PropTypes.object.isRequired,
	proxiedAs: userInfoShape,
	shareLinks: PropTypes.object,
	shareTexts: PropTypes.object,
	addShareItem: PropTypes.func.isRequired,
	onHide: PropTypes.func.isRequired,
	loadShareTexts: PropTypes.func.isRequired,
	fetchShareLink: PropTypes.func.isRequired,
};

export default SharePopoverContent;